import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import VConsole from 'vconsole'; // 引入 vConsole

// 只在非正式環境啟動
if (process.env.NODE_ENV !== 'production' || window.location.host.includes('uat')) {
  new VConsole();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
